import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import moment from 'moment';

//Services
import { EmployeeInfoService } from '../../../core/services/employee-info.service';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { UtilityService } from '../../../core/services/utility.service';
import { ChecklistService } from '../../checklist/services/checklist.service';
import { DailyReportsService } from '../../field/service/daily-reports.service';
import { EmployeeService } from '../services/employee.service';

@Component({
  selector: 'app-clock-in-out',
  templateUrl: './clock-in-out.component.html',
  styleUrls: ['./clock-in-out.component.css']
})
export class ClockInOutComponent implements OnInit, OnDestroy {
  @ViewChild('signaturePad', { static: false }) signaturePad: any;
  @ViewChild('clockInOutPage', { static: true }) clockInOutPage: ElementRef;
  portalSettings: any;
  employeeInfo: any;
  geolocationEnabled: boolean = false;
  requestingLocation: boolean = false;
  position: any = null;
  clockActionPerformed: boolean = false;
  performingClockAction: boolean = false;
  clockInUsePhase: boolean = false;
  prefillJP: boolean = false;
  customMsg: any;
  tCClockIOIgnoreJobPhase: boolean = false;
  formData: any = {};
  loadingClockStatus: boolean = false;
  jobs: any = [];
  phases: any = [];
  clockStatus: any;
  requireSign: any;
  signatureData: any;
  clockIn: any;
  clockActionSuccess: any;
  message: string;
  rawImgData: any;
  signatureNEmpty: any;
  submitSignImg: any = null;
  hideClick: boolean;
  showClickMsg: boolean;
  signed: boolean = false;
  read: boolean = false;
  redBorder: boolean;
  disableSubmitSign: boolean;
  panelWidth: number;
  kioskLogin: boolean = false;
  params: any;
  redirectTimeout: any;

  constructor(portalSettingsService: PortalSettingsService, employeeInfoService: EmployeeInfoService, private employeeService: EmployeeService, private dailyReportsService: DailyReportsService, private checklistService: ChecklistService, private route: ActivatedRoute, private utilityService: UtilityService) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
  }

  ngOnInit(): void {
    this.params = this.route.snapshot.queryParams;
    this.kioskLogin = this.params?.kioskLogin;
    this.clockInUsePhase = this.portalSettings.ClockInUsePhase.ConfigValue == '1';
    this.prefillJP = this.portalSettings.PrefillPerviousJobPhase.ConfigValue == '1';
    this.customMsg = this.portalSettings.CustomVerbiageClockOutSign.ConfigValue;
    this.tCClockIOIgnoreJobPhase = this.portalSettings.TCClockIOIgnoreJobPhase.ConfigValue == '1';
    this.requireSign = this.portalSettings.RequireSignClockOut.ConfigValue == '1';
    this.formData.selectedJob = null;
    this.formData.selectedPhase = null;
    this.redBorder = false;
    var width = this.clockInOutPage?.nativeElement?.clientWidth;
    this.panelWidth = (width > 550 ? 550 : width) + 30;
    this.getLocation();
    this.getClockInStatus();
  }

  ngOnDestroy(): void {
    clearTimeout(this.redirectTimeout);
  }

  postClockAction(ignoreLocation: boolean) {
    if (!this.loadingClockStatus && !this.requestingLocation) {
      this.performingClockAction = true;
      var requestObj = { clockInTime: new Date().toISOString(), gPSLat: null, gPSLong: null, jCJMKeyID: null, jCJPKeyID: null, signatureData: null, clockTimeString : null};
      if (!ignoreLocation && this.position) {
        requestObj.gPSLat = this.position.coords.latitude;
        requestObj.gPSLong = this.position.coords.longitude;
      }
      if (this.clockInUsePhase && !this.clockStatus) {
        requestObj.jCJMKeyID = this.formData.selectedJob.JCJMKeyID;
        requestObj.jCJPKeyID = this.formData.selectedPhase.JCJPKeyID;
      }
      if (this.signatureData != null)
        requestObj.signatureData = this.signatureData;

      var currentTime = moment();
      requestObj.clockTimeString = currentTime.format("MM/DD/YYYY h:mm:ss a");

      this.employeeService.postClockAction(requestObj).then((response: any) => {
        if (response != null) {
          this.clockActionPerformed = true;
          this.clockIn = response.resultClockAction;
          this.clockActionSuccess = response.success;
          if (response.success) {
            if (response.resultClockAction) {
              this.message = "Successfully clocked in at " + currentTime.format("hh:mm A");
              this.redirectToLogin();
            }
            else if (response.resultClockAction == false) {
              this.message = "Successfully clocked out at " + currentTime.format("hh:mm A");
              this.redirectToLogin();
            }
          } else {
            this.message = response.error;
          }
        }
      });
    }
  }

  jobChanged() {
    this.formData.selectedPhase = null;
    this.dailyReportsService.setJob(this.formData.selectedJob.JCJMKeyID, this.employeeInfo.UserKeyID);
    this.getPhases();
  }

  clockOutClicked() {
    if (this.requireSign) {
      this.checkSigned();
      if (this.formData.typeSign) {
        this.signatureData = (this.rawImgData);
        this.postClockAction(false);
      }
      else if (this.signatureNEmpty) {
        this.signatureData = (this.signaturePad.toDataURL().replace(/^data:image\/(png|jpg);base64,/, ""));
        this.postClockAction(false);
      }
    }
  }

  clickSign(type: any) {
    if (this.signaturePad.isEmpty()) {
      this.formData.typeSign = true;
      this.checklistService.getTypeSign(type).then((response: any) => {
        if (response != null) {
          this.rawImgData = response;
          this.submitSignImg = "data:image/png;base64," + response;
        }
      });
      this.hideClick = true;
      this.showClickMsg = false;
    } else {
      this.showClickMsg = true;
    }
  }

  clear() {
    if (this.signaturePad != null)
      this.signaturePad.clear();
    this.signatureNEmpty = false;
    this.rawImgData = null;
    this.submitSignImg = null;
    this.formData.typeSign = false;
    this.showClickMsg = false;
    this.hideClick = false;
  }

  searchJobs(term: string, item: any) {
    term = term.trim().toLowerCase();
    return item.JCJMKeyID?.toString().indexOf(term) > -1 || item.DisplayValue?.toLowerCase().indexOf(term) > -1;
  }

  searchPhases(term: string, item: any) {
    term = term.trim().toLowerCase();
    return item.JCJPKeyID?.toString().indexOf(term) > -1 || item.PhaseDescription?.toLowerCase().indexOf(term) > -1 || item.PhaseGroup?.toString().indexOf(term) > -1;
  }

  private getClockInStatus() {
    this.loadingClockStatus = true;
    var currentTime = moment();
    var currentTimeString = currentTime.format("MM/DD/YYYY h:mm:ss a");
    var requestParam = "fromFieldKiosk=" + false + "&currentTimeString=" + currentTimeString + "&where=" + 2;
    this.employeeService.getClockInStatus(requestParam).then((response: any) => {
      if (response != null) {
        this.clockStatus = response.ClockAction;
        this.loadingClockStatus = false;
        if (this.clockInUsePhase && !this.clockStatus) {
          this.getJobs();
        }
        else {
          if (!this.requestingLocation && this.geolocationEnabled && (!this.requireSign || !this.clockStatus)) {
            this.postClockAction(false);
          }
        }
      }
    });
  }

  private redirectToLogin() {
    this.redirectTimeout = setTimeout(() => {
      var loginURL = "/Account/Login";
      this.utilityService.isLoggedOut = true;
      if (this.kioskLogin) {
        window.location.href = "/Account/Logout?kioskLogout=true";
        loginURL = "/Account/Kiosklogin";
      }
      else {
        window.location.href = "/Account/Logout";
      }
      window.history.replaceState(null, null, loginURL);
    }, 5000);
  }

  private getLocation() {
    this.requestingLocation = true;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position: any) => {
        setTimeout(() => {
          this.requestingLocation = false;
          this.geolocationEnabled = true;
          this.position = position;

          //Prevent auto clock action if user is using job/phase while clocking in, or if user is using signature while clocking out, or if still loading clock status
          if ((!this.clockInUsePhase || this.clockStatus) && !this.loadingClockStatus && (!this.requireSign || !this.clockStatus)) {
            this.postClockAction(false);
          }
        }, 1000);
      });
      this.requestingLocation = false;
    }
    else {
      this.requestingLocation = false;
    }
  }

  private getJobs() {
    this.employeeService.getJobs('TC', '').then((response: any) => {
      if (response != null) {
        var jobs = response;
        jobs.forEach(val => {
          val.DisplayValue = "JCCo " + val.JCCo + " - " + val.JobDisplayName;
          if (this.employeeInfo.LastUsedJCJMKeyID != null && val.JCJMKeyID == this.employeeInfo.LastUsedJCJMKeyID && this.prefillJP) {
            this.formData.selectedJob = val;
          }
        });
        if (this.formData.selectedJob != null)
          this.getPhases();
        else {
          this.phases = [{ JCJPKeyID: null, Phase: "", PhaseDescription: "No Phase", PhaseGroup: null }];
          this.formData.selectedPhase = this.phases[0];
        }
        this.jobs = jobs;
        if (this.tCClockIOIgnoreJobPhase) {
          this.jobs.unshift({ JCJMKeyID: null, DisplayValue: "No Job", JCCo: null, Job: "", JobDescription: "", JobDisplayName: "" });
          if (this.formData.selectedJob == null)
            this.formData.selectedJob = this.jobs[0];
        }
      }
    });
  }

  private getPhases() {
    this.phases = [];
    if (this.formData.selectedJob.JCJMKeyID != null) {
      this.employeeService.getPhasesByJCJMKeyID(this.formData.selectedJob.JCJMKeyID, true).then((response: any) => {
        if (response != null) {
          this.phases = response;
          if (this.prefillJP) {
            this.phases.forEach(val => {
              if (this.employeeInfo.LastUsedJCJPKeyID != null && this.employeeInfo.LastUsedJCJPKeyID == val.JCJPKeyID) {
                this.formData.selectedPhase = val;
              }
            });
          }
          if (this.tCClockIOIgnoreJobPhase) {
            this.phases.unshift({ JCJPKeyID: null, Phase: "", PhaseDescription: "No Phase", PhaseGroup: null });
            if (this.formData.selectedPhase == null)
              this.formData.selectedPhase = this.phases[0];
          }
        }
      });
    } else {
      if (this.tCClockIOIgnoreJobPhase) {
        this.phases.unshift({ JCJPKeyID: null, Phase: "", PhaseDescription: "No Phase", PhaseGroup: null });
        if (this.formData.selectedPhase == null)
          this.formData.selectedPhase = this.phases[0];
      }
    }
  }

  private checkSigned() {
    if (this.signaturePad.isEmpty() == false) {
      this.signatureNEmpty = true;
      this.redBorder = false;
      this.disableSubmitSign = true;
    } else {
      this.redBorder = true;
    }
  }
}
